import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const TitleTableStyle = {
  titleHeader: css`
    display: flex;
    gap: 8px;
    justify-content: space-between;
    background: linear-gradient(
      180deg,
      rgba(255, 219, 36, 0.12) 0%,
      rgba(255, 219, 36, 0.06) 100%
    );
    border-top: 1px solid rgba(255, 219, 36, 0.35);
    border-bottom: 1px solid rgba(255, 219, 36, 0.35);
    min-height: 48px;
    align-items: center;
    color: ${theme.colors.lightText};
    font-weight: 600;
    letter-spacing: 0.3px;
  `,
  itemHeader: css`
    display: flex;
    justify-content: center;
    flex: 1;
    text-align: center;
    font-size: 13px;
    color: ${theme.colors.lightText};
  `,
};
